import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FunctionComponent } from 'react';

import {
  StyledCard,
  StyledLabel,
  StyledSummary,
  StyledSummaryRow,
  StyledTitle,
  StyledValue,
} from './summary-information-card.styled';

export interface SummaryItem {
  label: string;
  value: string;
}

interface SummaryInformationCardProps {
  title: string;
  content: React.ReactNode;
  summaryItems?: SummaryItem[];
}

export const SummaryInformationCard: FunctionComponent<SummaryInformationCardProps> = (props) => {
  const { title, content, summaryItems } = props;

  const renderSummary = (): React.ReactNode => {
    if (!summaryItems || !summaryItems.length) {
      return null;
    }

    return (
      <StyledSummary>
        {summaryItems.map((summaryItem, index) => (
          <StyledSummaryRow key={index}>
            <StyledLabel component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET}>
              {summaryItem.label}
            </StyledLabel>
            <StyledValue component="p" variant="paragraph2" maxBreakpoint={Breakpoint.TABLET}>
              {summaryItem.value}
            </StyledValue>
          </StyledSummaryRow>
        ))}
      </StyledSummary>
    );
  };

  return (
    <StyledCard>
      <StyledTitle component="h2" variant="paragraph1" maxBreakpoint={Breakpoint.TABLET}>
        {title}
      </StyledTitle>
      {content}
      {renderSummary()}
    </StyledCard>
  );
};
